import { render, staticRenderFns } from "./PodImages.vue?vue&type=template&id=2dc4fa44&"
import script from "./PodImages.vue?vue&type=script&lang=js&"
export * from "./PodImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports